import React from 'react';
import PropTypes from 'prop-types';
import { AQUA, GREY, WHITE } from '@wave-engagement/wave-react';
import { Typography } from '@mui/material';

const Slider = ({ value, onChange, style = {}, disabled = false, value1, value5 }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '20px 0', ...style }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
      }}>
        {/* Line */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '0%',
          right: '0%',
          height: '4px',
          backgroundColor: disabled ? 'lightgrey' : GREY,
          zIndex: 0,
          transform: 'translateY(-50%)',
        }} />
        
        {/* Circles */}
        {[...Array(5)].map((_, index) => {
          const isSelected = value === index + 1;
          return (
            <div
              key={index}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1,
                cursor: disabled ? 'default' : 'pointer',
                pointerEvents: disabled ? 'none' : 'auto',
                backgroundColor: isSelected ? AQUA : WHITE,
                border: `4px solid ${disabled ? 'lightgrey' : GREY}`,
              }}
              onClick={() => onChange(isSelected ? null : index + 1)}
            />
          );
        })}
      </div>

      {(value1 != null || value5 != null) && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: value1 == null ? 'flex-end' : 'space-between',
          color: disabled ? 'lightgrey' : undefined,
        }}>
          {value1 && <Typography variant='button' style={{ textTransform: 'uppercase', width: '50%', textAlign: 'left' }}>{value1}</Typography>}
          {value5 && <Typography variant='button' style={{ textTransform: 'uppercase', width: '50%', textAlign: 'right' }}>{value5}</Typography>}
        </div>
      )}
    </div>
  );
};

Slider.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  value1: PropTypes.string,
  value5: PropTypes.string,
};

export default Slider;
